// Lightweight product analytics — fire-and-forget, never send private content.

export const PRODUCT_DROPDOWN = 'PRODUCT_DROPDOWN';
export const POST_MATCH_PAGE = 'POST_MATCH_PAGE';
export const FEDERATION_PAGE = 'FEDERATION_PAGE';
export const TRIAL_CTA = 'TRIAL_CTA';
export const DEMO_CTA = 'DEMO_CTA';
export const CONTACT_SUBMIT = 'CONTACT_SUBMIT';
export const PRICING_PLAN = 'PRICING_PLAN';
export const FIRST_TEAM = 'FIRST_TEAM';
export const FIRST_MATCH = 'FIRST_MATCH';
export const FIRST_REPORT = 'FIRST_REPORT';
export const PROGRAM_CREATED = 'PROGRAM_CREATED';
export const FINDING_ACCEPTED = 'FINDING_ACCEPTED';
export const ACTION_ASSIGNED = 'ACTION_ASSIGNED';
export const REVIEW_COMPLETED = 'REVIEW_COMPLETED';
export const FEDERATION_EXPORT = 'FEDERATION_EXPORT';

const UNSAFE_PROP_KEYS = new Set([
  'password', 'passwd', 'token', 'secret', 'authorization',
  'message', 'text', 'body', 'content', 'report', 'finding_text',
  'findingText', 'notes', 'description', 'url', 'footage', 'footageUrl',
  'video', 'videoUrl', 'href', 'src',
]);

function isSafeScalar(value) {
  const t = typeof value;
  return t === 'string' || t === 'number' || t === 'boolean';
}

function sanitizeProps(props = {}) {
  const out = {};
  if (!props || typeof props !== 'object') return out;
  for (const [key, value] of Object.entries(props)) {
    if (UNSAFE_PROP_KEYS.has(String(key).toLowerCase())) continue;
    if (!isSafeScalar(value)) continue;
    if (typeof value === 'string' && value.length > 120) continue;
    // Skip values that look like URLs or passwords
    if (typeof value === 'string' && /https?:\/\//i.test(value)) continue;
    out[key] = value;
  }
  return out;
}

/**
 * Best-effort analytics event. Never throws. Never sends report text or footage URLs.
 */
export function track(eventName, props = {}) {
  try {
    if (!eventName || typeof eventName !== 'string') return;
    const safeProps = sanitizeProps(props);
    const headers = { 'Content-Type': 'application/json' };
    try {
      const token = localStorage.getItem('tactmark_token');
      if (token) headers.Authorization = `Bearer ${token}`;
    } catch (_) { /* ignore */ }

    fetch('/api/analytics', {
      method: 'POST',
      headers,
      body: JSON.stringify({ eventName, props: safeProps }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* ignore */ }
}
